var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"responsible-btn_add-card"},[_vm._v("Добавить ответственного")]),_c('div',{staticClass:"responsible__container"},[_c('ResponsibleCard'),_c('ResponsibleCard'),_c('ResponsibleCard')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }